/**
 * Parent page (JustMeds) listens for these via `window.addEventListener("message", ...)`.
 * TapType posts to a specific parent origin — never `"*"`.
 */
export const TT_IFRAME_CONSULTATION_DOCUMENTS_RECEIVED = "TTiframeConsultationDocumentsReceived";

/** Parent may listen for this when upload failed (e.g. toast + retry on their side). */
export const TT_IFRAME_CONSULTATION_DOCUMENTS_FAILED = "TTiframeConsultationDocumentsFailed";

export const TT_IFRAME_NOTE_CREATED = "TTiframeNoteCreated";

export const TT_IFRAME_CLICK = "TTiframeClick";

const DEFAULT_JUSTMEDS_API_BASE_URL = "https://secure.justmeds.ca";
const PARENT_FAILURE_MESSAGE_MAX = 200;

const tryParseOrigin = (value = "") => {
	if (!value || typeof value !== "string") return null;
	try {
		return new URL(value).origin;
	} catch {
		return null;
	}
};

/** Resolve the JustMeds parent origin for iframe postMessage (build-time env → referrer → API base URL). */
export const getJustmedsIframePostMessageTargetOrigin = () => {
	const configured = process.env.REACT_APP_JUSTMEDS_PARENT_ORIGIN?.trim();
	if (configured) {
		const configuredOrigin = tryParseOrigin(configured);
		if (configuredOrigin) return configuredOrigin;
	}

	if (typeof document !== "undefined") {
		const referrerOrigin = tryParseOrigin(document.referrer);
		if (referrerOrigin) return referrerOrigin;
	}

	const apiBase = process.env.REACT_APP_JUSTMEDS_API_BASE_URL || DEFAULT_JUSTMEDS_API_BASE_URL;
	return tryParseOrigin(apiBase);
};

export const postMessageToJustmedsParent = (payload) => {
	if (typeof window === "undefined" || window.location === window.parent.location) return;
	const targetOrigin = getJustmedsIframePostMessageTargetOrigin();
	if (!targetOrigin) return;
	window.parent.postMessage(payload, targetOrigin);
};

function truncateForParentMessage(text) {
	if (text == null || typeof text !== "string") return undefined;
	const t = text.trim();
	if (!t) return undefined;
	return t.length <= PARENT_FAILURE_MESSAGE_MAX ? t : `${t.slice(0, PARENT_FAILURE_MESSAGE_MAX)}…`;
}

export function notifyJustmedsParentConsultationDocumentsReceived({ note }) {
	postMessageToJustmedsParent({
		type: TT_IFRAME_CONSULTATION_DOCUMENTS_RECEIVED,
		timestamp: new Date().toISOString(),
		noteId: note?.short_id,
	});
}

export function notifyJustmedsParentConsultationDocumentsFailed({ note, message }) {
	const safe = truncateForParentMessage(message);
	postMessageToJustmedsParent({
		type: TT_IFRAME_CONSULTATION_DOCUMENTS_FAILED,
		timestamp: new Date().toISOString(),
		...(note?.short_id != null ? { noteId: note.short_id } : {}),
		...(safe ? { message: safe } : {}),
	});
}
